import { PersistenceService, IPersistable, PersistMode } from '@barthauer/abc/core/data';

export class ChangedObjectPackage {
  object: IPersistable;
  fieldValueHistories: {} = {};
}

export class FieldValueHistory {
  originalValue: any;
  newValue: any;
  get hasChanged(): boolean {
    return this.originalValue !== this.newValue;
  }
}

export class ValueWrapper {
  private _value: any;
  private _objectKey: IPersistable;
  private _fieldName: string;
  get value(): any {
    return this._value;
  }
  set value(value: any) {
    this.persistenceService.addObjectValue(this._objectKey, this._fieldName, value, this._value);
    this._value = value;
  }
  constructor(
    private fieldName: string,
    private initValue: any,
    private objectKey: IPersistable,
    private persistenceService: PersistenceService
  ) {
    this._value = initValue;
    this._objectKey = objectKey;
    this._fieldName = fieldName;
  }
}

export class ValueWrapperViewModel implements IPersistable {
  id: string;
  objectType: string;
  persistenceCategory: string;
  listOfValueWrappers: any;
  abcComponentContainer: any;

  constructor(private persistenceService: PersistenceService) {}

  changesPersisted(persistMode: PersistMode) {}
  revertChanges() {
    const pack = this.persistenceService.getPendingObjectPackage(this);
    for (let property in pack.fieldValueHistories) {
      pack.setOriginalFieldHistoryValue(property, (value) => {
        pack.fieldValueHistories[property].newValue = value;
        this.listOfValueWrappers[property].value = value;
      });

      let index = this.abcComponentContainer.findIndex((element) => element.id === property);
      this.abcComponentContainer[index].componentRef.value = this.listOfValueWrappers[property].initValue;
    }
  }
}
